import { submitAuthorizationApproval } from "./oauth.apis"

const state = {
  formError: null,
  isSubmitting: false,
}

const getters = {
  formError: state => state.formError,
  isSubmitting: state => state.isSubmitting,
}

const mutations = {
  SET_FORM_ERROR: (state, error) => (state.formError = error),
  SET_IS_SUBMITTING: (state, isSubmitting) => (state.isSubmitting = isSubmitting),
}

const actions = {
  async submitAuthorizationApproval ({ state, commit }, isApproved) {
    if (state.isSubmitting) {
      return
    }

    try {
      commit("SET_FORM_ERROR", null);
      commit("SET_IS_SUBMITTING", true)
      await submitAuthorizationApproval(isApproved)
    } catch (e) {
      commit("SET_FORM_ERROR", e?.response?.data?.error ?? "An unknown error occurred.");
    } finally {
      commit("SET_IS_SUBMITTING", false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/oauth/oauth.module.js